
import React, { useState } from "react";
import ShopifyModal from "../../../../../components/ShopifyModal";
const Index = ({open,setIsEnough,needNum,currentPoints}) => {
    const [saveLoading, setSaveLoading] = useState(false);
    const handleSave = async () => {
        setSaveLoading(true);
        setIsEnough((prevValue)=>({...prevValue,isLess:false}))
      };
      const formatNumber = (value) => {
        value += '';
        const list = value.split('.');
        const prefix = list[0].charAt(0) === '-' ? '-' : '';
        let num = prefix ? list[0].slice(1) : list[0];
        let result = '';
        while (num.length > 3) {
          result = `,${num.slice(-3)}${result}`;
          num = num.slice(0, num.length - 3);
        }
    
        if (num) {
          result = num + result;
        }
        return `${prefix}${result}${list[1] ? `.${list[1]}` : ''}`;
      };
  return (
    <div className="upgrade_new_feature">
      <ShopifyModal id="redem-product-less-modal"
        open={open}
        onClose={() => 
          {
            setIsEnough((prevValue)=>({...prevValue,isLess:false}))
            setSaveLoading(false)
          }}
        heading={'Insufficient Points'}
        primaryAction={{
          content: "OK",
          loading:saveLoading,
          onAction: () => {
            handleSave()
          },
        }}
        
      >
        <p style={{fontSize:'14px'}}>{`The item you selected requires ${formatNumber(needNum)} points, but you don’t have enough points. Please choose other items. (Remaining points: ${formatNumber(currentPoints)})`}</p>
        </ShopifyModal>
    </div>
  );
};

export default Index;
